import React from 'react';
import { BooleanInput, ReferenceArrayInput, ReferenceInput, required, SelectInput, TextInput } from 'react-admin';
import { withStyles } from '@material-ui/styles';
import FormSectionDescription from '../../../../components/FormSectionDescription';
import StyledSimpleForm from '../../../../components/StyledSimpleForm';
import { StyledPage } from '../../../../components/StyledPage';
import CreateHeader from '../../../../components/CreateHeader';
import { CreateBody } from '../../../../components/CreateBody';
import CustomToolbar from '../../CustomToolbar';
import LanguagesInput from './LanguagesInput';
import { getConsentItemTypeText } from '../../../../utils/getConsentItemType';

const styles = {
  description: {
    width: '100%',
    marginBottom: '24px',
  },
  input: {
    width: '299px',
    display: 'inline-block',
  },
};

const BasicInfo = ({ onSubmit, classes, data, solutionID, ...rest }) => {
  return (
    <StyledPage>
      <CreateHeader
        title={data.id ? 'Edit Consent Item' : 'Create Consent Item'}
        subTitle="Fill in details about your consent item"
      />
      <CreateBody {...rest}>
        <StyledSimpleForm initialValues={data} toolbar={<CustomToolbar onSubmit={onSubmit} solutionID={solutionID}/>} {...rest} >
          <div className={classes.description}>
            <FormSectionDescription title="Item details"/>
          </div>
          <TextInput source="name" validate={required()} className={classes.input} fullWidth/>
          <ReferenceInput label="Type" source="universalConsentItemType" className={classes.input} reference="universal_consent_item_types">
            <SelectInput optionText={getConsentItemTypeText} optionValue="@id" className={classes.input} fullWidth validate={required()}
              data-testid="universal-consent-item-type-field"/>
          </ReferenceInput>
          <BooleanInput label="Required" source="required" data-testid="universal-consent-item-required-field"/>
          <div className={classes.description}>
            <FormSectionDescription title="Languages"
              description="Select the languages your Consent Solution will be available in. You can always add or remove languages later."/>
          </div>
          <div className={classes.input}>
            <ReferenceArrayInput source="languagesIDs" reference="languages" validate={required()} filter={{ itemsPerPage: 500 }}>
              <LanguagesInput/>
            </ReferenceArrayInput>
          </div>
        </StyledSimpleForm>
      </CreateBody>
    </StyledPage>
  );
};

export default withStyles(styles)(BasicInfo);
